
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-c-1-d-wwm-0-z-i-2-a-kc-s-au-s-62-ou-4-i.json") })
        }
      }, "path---projects-c-1-d-wwm-0-z-i-2-a-kc-s-au-s-62-ou-4-i");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---projects-c-1-d-wwm-0-z-i-2-a-kc-s-au-s-62-ou-4-i!./.cache/json/projects-c-1-d-wwm-0-z-i-2-a-kc-s-au-s-62-ou-4-i.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---projects-c-1-d-wwm-0-z-i-2-a-kc-s-au-s-62-ou-4-i!./.cache/json/projects-c-1-d-wwm-0-z-i-2-a-kc-s-au-s-62-ou-4-i.json
// module chunks = 15178676390636814000